<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
  }
}
</script>
<style>

@media (max-width: 1200px){}
@media (max-width: 1024px){}
@media (max-width: 992px){}
@media (max-width: 786px){}
@media (max-width: 468px){}

</style>